<script>
	import defines from './defines.js'

	let wallets = "";
	let info = ""
	let networkSelected

	async function handleClick() {
		info = ""
		let lstWallet = wallets.split("\n")
		for (let i=0; i<lstWallet.length; i++) {
			if (lstWallet[i].trim() != "") {
				let url = "https://api.covalenthq.com/v1/" + networkSelected.id + "/address/" + lstWallet[i].trim() + "/balances_v2/?key=ckey_562677ec95c64f92a927a47ca24"
				const res = await fetch(url, {
					method: 'GET',
				})
				
				const json = await res.json()				
				if (!json.error) {
					info += json.data.address + "\n"
					info += "--------------------------------------------------------------- \n"	
					for (let j=0; j<json.data.items.length; j++) {
						if (json.data.items[j].balance > 0) {
							if (!defines.scam_tokens.includes(json.data.items[j].contract_address)) {
								let balance = json.data.items[j].balance/Math.pow(10, json.data.items[j].contract_decimals)
								let contractName = json.data.items[j].contract_name
								let contractSymbol = json.data.items[j].contract_ticker_symbol
								if (contractName != null && contractSymbol != null) {
									info += (contractName + "   " + contractSymbol + "   " + balance + "\n")
								}
							}										
						}			
					}
				} else {
					info += json.error_message + "\n"
				}
				info += "_____________________________________________________________ \n"	
				info += "_____________________________________________________________ \n"	
				info += "_____________________________________________________________ \n"	
			}
		}
	};
	
</script>

<main>
	<h1>Lấy thông tin tài khoản</h1>
	<select bind:value={networkSelected}>
		{#each defines.networks as network}
			<option value={network}>
				{network.text}
			</option>
		{/each}
	</select>
	
	<button on:click={handleClick}>
		Lấy thông tin
	</button>
	
	<h5 style="color: red;">*Mỗi địa chỉ nằm trên 1 dòng</h5>
	<textarea id="in" bind:value={wallets}></textarea>
	
	<textarea bind:value={info}></textarea>
<style>
	
</style>
</main>

<style>
	textarea { width: 100%; height: 600px; }
	#in { width: 100%; height: 200px; }

	main {
		text-align: center;
		padding: 1em;
		max-width: 90%;
		margin: 0 auto;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>